import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { RootState } from "../../../redux/store";
import {
  createContentManagementVersion,
  getAllContentManagementVersions,
  getContentManagementVersionById,
  updateContentManagementVersion,
  deleteContentManagementVersion,
  createContentManagement,
  getAllContentManagements,
  getContentManagementById,
  updateContentManagement,
  deleteContentManagement,
  createContentManagementTranslation,
  getAllContentManagementTranslations,
  getContentManagementTranslationById,
  updateContentManagementTranslation,
  deleteContentManagementTranslation,
  getTranslationsByContentType,
  getContentManagementByType,
  getContentManagementByVersionId,
  getContentManagementTranslationsByContentId,
} from "../../../redux/Actions/ContentManagementAction";
import {
  clearSelectedVersion,
  clearSelectedContent,
  clearSelectedTranslation,
  clearAllSelected,
  setSelectedVersion,
  setSelectedContent,
  setSelectedTranslation,
  clearError,
  resetContentManagementState,
} from "../../../redux/Slices/contentManagementSlice";

export const useContentManagement = () => {
  const dispatch = useAppDispatch();
  
  // Selectors
  const versions = useAppSelector((state: RootState) => state.contentManagement.versions);
  const contentManagements = useAppSelector((state: RootState) => state.contentManagement.contentManagements);
  const translations = useAppSelector((state: RootState) => state.contentManagement.translations);
  const loading = useAppSelector((state: RootState) => state.contentManagement.loading);
  const error = useAppSelector((state: RootState) => state.contentManagement.error);
  const selectedVersion = useAppSelector((state: RootState) => state.contentManagement.selectedVersion);
  const selectedContent = useAppSelector((state: RootState) => state.contentManagement.selectedContent);
  const selectedTranslation = useAppSelector((state: RootState) => state.contentManagement.selectedTranslation);

  // Actions
  const actions = {
    // Version actions
    createVersion: (payload: any) => dispatch(createContentManagementVersion(payload)),
    getAllVersions: (params?: { page?: number; limit?: number; isShowLoader?: boolean }) => 
      dispatch(getAllContentManagementVersions(params || {})),
    getVersionById: (id: string, isShowLoader?: boolean) => 
      dispatch(getContentManagementVersionById({ id, isShowLoader })),
    updateVersion: (id: string, data: any) => 
      dispatch(updateContentManagementVersion({ id, data })),
    deleteVersion: (id: string) => dispatch(deleteContentManagementVersion({ id })),

    // Content actions
    createContent: (payload: any) => dispatch(createContentManagement(payload)),
    getAllContents: (params?: { page?: number; limit?: number; isShowLoader?: boolean }) => 
      dispatch(getAllContentManagements(params || {})),
    getContentById: (id: string, isShowLoader?: boolean) => 
      dispatch(getContentManagementById({ id, isShowLoader })),
    updateContent: (id: string, data: any) => 
      dispatch(updateContentManagement({ id, data })),
    deleteContent: (id: string) => dispatch(deleteContentManagement({ id })),
    getContentByType: (type: number, isShowLoader?: boolean) => 
      dispatch(getContentManagementByType({ type, isShowLoader })),
    getContentByVersionId: (versionId: string, isShowLoader?: boolean) => 
      dispatch(getContentManagementByVersionId({ versionId, isShowLoader })),

    // Translation actions
    createTranslation: (payload: any) => dispatch(createContentManagementTranslation(payload)),
    getAllTranslations: (params?: { page?: number; limit?: number; isShowLoader?: boolean }) => 
      dispatch(getAllContentManagementTranslations(params || {})),
    getTranslationById: (id: string, isShowLoader?: boolean) => 
      dispatch(getContentManagementTranslationById({ id, isShowLoader })),
    updateTranslation: (id: string, data: any) => 
      dispatch(updateContentManagementTranslation({ id, data })),
    deleteTranslation: (id: string) => dispatch(deleteContentManagementTranslation({ id })),
    getTranslationsByContentType: (contentManagementTypeId: string, isShowLoader?: boolean) => 
      dispatch(getTranslationsByContentType({ contentManagementTypeId, isShowLoader })),
    getContentManagementTranslationsByContentId: (contentId: string, isShowLoader?: boolean) => 
      dispatch(getContentManagementTranslationsByContentId({ contentId, isShowLoader })),

    // State management actions
    setSelectedVersion: (version: any) => dispatch(setSelectedVersion(version)),
    setSelectedContent: (content: any) => dispatch(setSelectedContent(content)),
    setSelectedTranslation: (translation: any) => dispatch(setSelectedTranslation(translation)),
    clearSelectedVersion: () => dispatch(clearSelectedVersion()),
    clearSelectedContent: () => dispatch(clearSelectedContent()),
    clearSelectedTranslation: () => dispatch(clearSelectedTranslation()),
    clearAllSelected: () => dispatch(clearAllSelected()),
    clearError: () => dispatch(clearError()),
    resetState: () => dispatch(resetContentManagementState()),
  };

  return {
    // State
    versions,
    contentManagements,
    translations,
    loading,
    error,
    selectedVersion,
    selectedContent,
    selectedTranslation,
    
    // Actions
    ...actions,
  };
};
